export enum OpType {
    WriteYourOwn,
    MaintenanceMenu,
    WeOwe,
    Recall,
    RecommendedService,
    IndividualService,
    ConditionalMaintMenu,
    SkipServiceReason,
    ViewApptListService,
    Diagnosis,
}

export interface Appointment {
    date: string;
    time: string;
    trans: string;
    advisor: string;
    advisorOptionEN: string;
    advisorOptionFR: string;
    department: string;
    advName: string;
    advImage: string;
    transFlag: string;
    apptNum?: string;
}

export interface ApptDate {
    date: string;
    time: string;
    trans: string;
    transFlag: string;
    advisor: string;
}

export interface EmployeeChanges {
    empFirst?: string,
    empLast?: string,
    empEmail?: string,
    empPhone?: string,
}

export interface ApptCust {
    custNameId?: string;
    custFirstName: string;
    custLastName: string;
    custEmailAddress: string;
    custPhoneNumber: string;
    custPhoneType?: string;
    custPrefContact: string;
    custLoggedIn?: boolean;
}

export interface ApptVeh {
    vin: string;
    makeCode: string;
    make: string;
    model: string;
    series: string;
    vehYr: string;
    vehColor: string;
    mileage: number;
    imagePath: string;
    spgModelId?: string;
    optionId?: string;
    engineId?: string;
}

export interface NextAppointmentOp {
    opDesc: string;
    opQuote: string;
    opCode: string;
}

export interface ViewApptList extends Array<ViewAppt> { }

export interface ViewAppt {
    apptNum: string;
    vin: string;
    makeCode: string;
    make: string;
    model: string;
    year: string;
    date: string;
    time: string;
    ApptOps: NextAppointmentOp[];
    advImage: string;
    advName: string;
    advisorOptionEN: string;
    advisorOptionFR: string;
    advisor: string;
    trans: string;
    transFlag: string;
    mileage: number;
    department: string;
    scheduleOption: string;
    mileageMenu: string;
    conditionalMenus: string[];
}

export interface ApptOps {
    id: string;
    operation: string;
    concern: string;
    estTime: string;
    menuID: string;
    spgOp: string;
    itemCostLow?: string;
    itemCostHigh?: string;
    opType: OpType;
    department: string;
    opWaiter: string;
    opLoaner: string;
    opRental: string;
    opConcierge: string;
    opCadillac: string;
    opPPUDWL: string;
}

export interface UpdateApptDateInp {
    selDate: string;
    selTime: string;
    selTrans: string;
    selAdv: string;
    selAdvName: string;
    selAdvImage: string;
    selTransFlag: string;
    selApptNum?: string;
}

export interface UpdateApptCustInp {
    nameId?: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    phoneType?: string;
    prefContact: string;
    loggedIn?: boolean;
}

export interface UpdateApptOpsInp {
    id: string;
    operation: string;
    concern: string;
    estTime: string;
    menuID: string;
    spgOp: string;
    itemCostLow?: string;
    itemCostHigh?: string;
    opType: OpType;
    department: string;
    opWaiter: string;
    opLoaner: string;
    opRental: string;
    opConcierge: string;
    opCadillac: string;
    opPPUDWL: string;
}

export interface UpdateApptVehInp {
    vin: string;
    makeCode: string,
    make: string,
    model: string,
    series: string,
    vehYr: string,
    vehColor: string,
    mileage: number,
    imagePath: string,
    spgModelId?: string,
    optionId?: string,
    engineId?: string,
}

export interface ApptError {
    errorMsg: string;
    errorCode: string;
}

export interface DeteremineDeptInp {
    defaultDept: string;
}

// Pickup & Dropoff/Delivery address information
// Pickup
export interface ApptPULoc {
    puAddress: string;
    puAddress2: string;
    puZipPostal: string;
    puCity: string;
    puStateProvince: string;
}
// Dropoff
export interface ApptDOLoc {
    doAddress: string;
    doAddress2: string;
    doZipPostal: string;
    doCity: string;
    doStateProvince: string;
}
// Additional comments
export interface ApptLocCom {
    pudoAddComments: string;
}
// ZIP search results
export interface ZIPSearchReturn {
    city: string;
    state: string;
}